import { Icon } from '@iconify/react';
import React from "react";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../../helpers/api";
import { FaUserCircle } from "react-icons/fa";

export default function TeamStyle2({
  picture,
  department,   // department_id
  firstname,
  lastname,
  name,
  degree,
  designation,
  short_biography,
  specialty,    // human-readable name
  specialist,
  doctorId,
  facebook,
  linkedin,
  instagram,
}) {
  const navigate = useNavigate();

  

  const handleBookAppointment = () => {
    // Persist specialty/department ID
    if (department) {
      localStorage.setItem("selectedSpeciality", String(department));
    }

    // Persist selected doctor
    if (doctorId) {
      localStorage.setItem(
        "selectedDoctor",
        JSON.stringify({
          id: doctorId,
          name: `${firstname || ""} ${lastname || ""}`.trim() || name,
           degree: degree || "",         
           specialist: specialist || "", 
        })
      );
    }

    navigate("/appointments");
  };

  const social = [
  { icon: "fa6-brands:facebook-f", href: facebook || "" },
  { icon: "fa6-brands:linkedin-in", href: linkedin || "" },
  { icon: "fa6-brands:instagram", href: instagram || "" },
];

  return (
    <div className="cs_team cs_style_1 cs_type_2 text-center cs_radius_20 overflow-hidden">
     <div className="cs_member_img" style={{ height: "554px", overflow: "hidden" }}>
        {picture ? (
          <img
            src={picture}
            alt={name}
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        ) : (
          <div style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#ffffff",
            fontSize: "120px",
            color: "#9e9e9e"
          }}>
            <FaUserCircle
            size={250}
            color="#5aa9e6"
          />
          </div>
        )}
        <div className="cs_label cs_white_color cs_accent_bg">
          {specialty} Department
        </div>
      </div>

      <div className="cs_team_meta cs_white_bg">
        <div>
          <h3 className="cs_member_name cs_fs_32">{name}</h3>
          <p className="cs_member_designation cs_heading_color cs_medium">{specialist}</p>
          <p className="cs_member_description">{short_biography?.replace(/<[^>]+>/g, "")}</p>
        </div>

        <div className="cs_team_btn_wrap" style={{ marginTop: "1rem" }}>
          <button onClick={handleBookAppointment} className="cs_btn cs_style_1">
            <span>Book Appointment</span>
          </button>
        </div>

        <div className="cs_social_links mt-3">
        {social?.filter(item => item.href).map((item, index) => (
          <a key={index} href={item.href} target="_blank" rel="noopener noreferrer" className="cs_social_icon">
            <Icon icon={item.icon} />
          </a>
        ))}
      </div>
      </div>
    </div>
  );
}
